export default __webpack_public_path__ + "static/media/Map.9c095148.png";